// extracted by mini-css-extract-plugin
export default {"productGallery":"BN-z","inQuickShop":"CN-z"};